import React, { Component } from "react";
import { Modal } from "antd";

class EmptyModal extends Component {
    state = { visible: false }
    showModal = () => {
    	this.setState({
    		visible: true,
    	});
    }
    handleOk = (e) => {
    	this.setState({
    		visible: false,
    	});
    }
    handleCancel = (e) => {
    	this.setState({
    		visible: false,
    	});
    }
    render() {
    	const { children, title = "", width = 800 } = this.props;
    	return (
    		<div>
    			<Modal
    				title={title}
    				visible={this.state.visible}
    				onOk={this.handleOk}
    				onCancel={this.handleCancel}
    				footer={null}
    				width={`${width}px`}
    			>
    				{children}
    			</Modal>
    		</div>
    	);
    }
}

export default EmptyModal;


// WEBPACK FOOTER //
// ./src/components/modal/EmptyModal.js